<template>
    <v-row align="center">
        <v-col cols="auto" class="py-0">
            <v-img v-if="value" :src="createObjectURL(value)" width="128" height="128"></v-img>
            <v-responsive v-else width="128" height="128">
                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                    <v-icon>mdi-image</v-icon>
                </v-row>
            </v-responsive>
        </v-col>
        <v-col class="py-0">
            <v-file-input label="썸네일 업로드" placeholder=" " show-size accept="image/*" @change="input"></v-file-input>
        </v-col>
        <v-col v-if="value" cols="auto" class="py-0 pl-0">
            <v-btn icon @click="$emit('remove')"><v-icon>mdi-delete</v-icon></v-btn>
        </v-col>
    </v-row>
</template>
<script>
export default {
    props: {
        value: { type: File, default: null },
    },
    methods: {
        input(file){
            this.$emit("input", file);
        },

        createObjectURL(file){
            try{ return URL.createObjectURL(file); }
            catch(error){}
        }
    }
}
</script>